/* eslint-disable @typescript-eslint/no-unused-vars */
import { Key, useMemo } from 'react';
import { useState, useEffect } from 'react';
import { Tree, message, Spin, Modal } from 'antd';
import { CaretDownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { ItemRender } from './components';
import { cloneDeep } from 'lodash-es';
// import { label, login } from '@/services/ant-design-pro';
import type { DataNode } from 'antd/lib/tree';
import type { NodeDragEventParams } from 'rc-tree/lib/contextTypes';
// import { DoubtCircle, Add, ModifyProperties, Delete } from 'patternx-svg';
import AppSetting from './components/AppSetting';
import {
  getComponentTags,
  getComponentApps,
  addComponentTag,
  updateComponentTag,
  getComponentTagLink,
  deleteComponentTag,
  updateComponentTagPosition,
} from '@/services/source';
import TransferClass from './components/TransferClass';
import { useCallbackFn } from '@/hooks';

const deepfind: (
  arr: ELEMENT.LabelItem[],
  cb: (data: ELEMENT.LabelItem) => boolean,
) => ELEMENT.LabelItem | null = (
  arr: ELEMENT.LabelItem[],
  cb: (data: ELEMENT.LabelItem) => boolean,
) => {
  for (let i = 0; i < arr.length; i++) {
    if (cb(arr[i])) return arr[i];
    if (arr[i].children) {
      const res = deepfind(arr[i].children as ELEMENT.LabelItem[], cb);
      if (res) return res;
    }
  }
  return null;
};
const formattree: (
  arr: ELEMENT.ResLabelItem[],
  res: ELEMENT.LabelItem[],
  disableId?: string,
) => ELEMENT.LabelItem[] = (
  arr: ELEMENT.ResLabelItem[],
  res: ELEMENT.LabelItem[],
  disableId?: string,
) => {
  // eslint-disable-next-line no-param-reassign
  res = arr.map((item) => {
    const { id, name, children } = item;
    return {
      ...item,
      title: name,
      key: id,
      label: name,
      value: id,
      disabled: disableId && id === disableId ? true : false,
      children: formattree(children as ELEMENT.ResLabelItem[], [], disableId),
    };
  });
  return res;
};

const formatData: any = (list: any) => {
  return list.map((item: any) => {
    return {
      title: item.name,
      id: item.code, // 数据操作使用 key, 新建结点只有key没有id
      key: item.code,
      count: item.linkCnt,
    };
  });
};

interface IStateModalLabel {
  visible: boolean;
  onCancel: (isRefresh: boolean) => void;
}
const ModalLabel = (props: IStateModalLabel) => {
  const [arr, setArr] = useState<ELEMENT.LabelItem[]>([]);
  const [, setCurrentLabelItem] = useState<ELEMENT.LabelItem>(arr[0]);
  const [initArr, setInitArr] = useState<ELEMENT.LabelItem[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<Key[]>(['all']);
  const [editing, setEditing] = useState<boolean>(false);
  const [spinning, setSpinning] = useState<boolean>(false);
  const [val, setVal] = useState<string>('');
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(false);
  const [, setClickPanelItem] = useState<boolean>(false);
  const [isClickTreeItem, setClickTreeItem] = useState<boolean>(true);
  const [selectData, setSelectData] = useState<ELEMENT.LabelItem[]>([]);
  const [switchLoading, setSwitchLoading] = useState(false);
  const [settingDataTree, setSettingDataTree] = useState<any[]>([]);
  const [currentClazz, setCurrentClazz] = useState<any>({ id: 'category' });
  const [showTransferClassModal, setShowTransferClassModal] = useState(false);
  const [deleteTagId, setDeleteTagId] = useState('');
  const [isRefreshList, setIsRefreshList] = useState(false);

  const getLabels = async (node?: any) => {
    setEditing(false);
    setSpinning(true);
    setSwitchLoading(true);
    const res = await getComponentTags();
    if (res?.success) {
      const data = res?.data?.details || [];
      let newAry = data;
      if (data.length > 0) {
        newAry = formattree(data, []);
      }
      setArr(newAry);
      setInitArr(newAry);
      if (node) {
        setSelectData([node]);
      }
      //  else {
      //   setSelectData([newAry[0]]);
      // }
      setExpandedKeys(expandedKeys);
    }
    setSwitchLoading(false);
    setSpinning(false);
  };

  const fetchAppOptions = async () => {
    const res = await getComponentApps('app', true);
    if (res?.success) {
      setSettingDataTree(formatData(res?.data?.details || []));
    }
  };

  useEffect(() => {
    getLabels();
    fetchAppOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAdd = (node: ELEMENT.LabelItem) => {
    const newArr = cloneDeep(arr);
    if (node.key === 'all') {
      newArr.unshift({
        expanded: false,
        id: '',
        level: node.level + 1,
        name: '',
        tagCode: '',
        isAdd: true,
        title: '',
        pid: 'all',
        key: Date.now().toString(),
        children: [] as ELEMENT.LabelItem[],
      });
    } else {
      const item = deepfind(newArr, (treeNode: ELEMENT.LabelItem) => treeNode.key === node.key);
      if (item) {
        setExpandedKeys((keys) => [...keys, item.key]);
        item.children.unshift({
          expanded: false,
          id: '',
          level: item.level + 1,
          name: '',
          tagCode: '',
          isAdd: true,
          title: '',
          pid: item.id,
          key: Date.now().toString(),
          children: [] as ELEMENT.LabelItem[],
        });
      }
    }
    setArr(newArr);
  };
  const handleSave = async (node: ELEMENT.LabelItem, name: string) => {
    const res = await updateComponentTag({
      tagId: node.id,
      name,
    });
    if (res?.success) {
      message.success('更新成功');
      getLabels();
    }
  };
  const handleCreate = async (node: ELEMENT.LabelItem, name: string) => {
    const res = await addComponentTag({
      pid: node.pid === 'all' ? '' : node.pid,
      name,
    });
    setVal('');
    if (res?.success) {
      message.success('新建成功');
      getLabels(res);
    }
  };
  const getParentKey: (value: string, tree: ELEMENT.LabelItem[]) => any = (
    value: string,
    tree: ELEMENT.LabelItem[],
  ) => {
    const parentKeys = tree.map((item) => {
      if (item.title.indexOf(value) > -1) {
        return item.key;
      } else {
        return getParentKey(value, item.children);
      }
    });
    return parentKeys;
  };
  const filterData = (value: string) => {
    const newExpandedKeys = initArr
      .map((item) => {
        if (item.title.indexOf(value) > -1) {
          return item.key;
        } else {
          return getParentKey(value, item.children);
        }
      })
      .flat(Infinity)
      .filter((item) => !!item);
    const newData: ELEMENT.LabelItem[] = [];
    initArr
      .map((item) => {
        if (item.title.indexOf(value) > -1) {
          return item.key;
        } else {
          return getParentKey(value, item.children);
        }
      })
      .map((item) => {
        if (Array.isArray(item)) {
          return item.flat(Infinity);
        } else {
          return [item];
        }
      })
      .forEach((el, index) => {
        if (!!el.length) {
          newData.push(initArr[index]);
        }
      });
    setExpandedKeys((keys) => [...keys, ...newExpandedKeys]);
    setArr(newData);
    setCurrentLabelItem(newData[0]);
    setAutoExpandParent(true);
  };
  const handleDelete = async (node: ELEMENT.LabelItem) => {
    if (node?.isAdd) {
      if (val) {
        filterData(val);
      } else {
        setArr(initArr);
        setCurrentLabelItem(initArr[0]);
      }
    } else {
      Modal.confirm({
        title: '是否确认删除',
        icon: <ExclamationCircleOutlined />,
        okText: '确认',
        cancelText: '取消',
        centered: true,
        onOk: async () => {
          setVal('');
          const res = await getComponentTagLink(node.id);
          if (res?.data?.details?.length > 0) {
            setShowTransferClassModal(true);
            setDeleteTagId(node.id);
          } else {
            const res1 = await deleteComponentTag(node.id);
            if (res1?.success) {
              message.success('分类已删除');
              getLabels();
            }
            setDeleteTagId('');
          }
          // if (res?.success) {
          //   getLabels();
          // } else {
          //   message.error(res?.message);
          //   const newArr = cloneDeep(arr);
          //   const item = deepfind(
          //     newArr,
          //     (treeNode: ELEMENT.LabelItem) => treeNode.key === node.key,
          //   );
          //   if (item) {
          //     item.flag = true;
          //     setArr(newArr);
          //     setCurrentLabelItem(newArr[0]);
          //   }
          // }
        },
      });
    }
  };

  const handleExpand = (keys: Key[]) => {
    setExpandedKeys(keys);
    setAutoExpandParent(false);
  };

  const findParentNode = (arr1: ELEMENT.LabelItem[], id1: string) => {
    const nodes: ELEMENT.LabelItem[] = [];
    const forFn = (ary: ELEMENT.LabelItem[], id: string) => {
      for (let i = 0; i < ary.length; i++) {
        const item = ary[i];
        if (item.id === id) {
          nodes.push(item);
          forFn(arr1, item.pid);
          break;
        } else {
          if (item.children) {
            forFn(item.children, id);
          }
        }
      }
    };
    forFn(arr1, id1);
    return nodes;
  };
  const getTreeItem = (item: ELEMENT.LabelItem) => {
    const newAry: ELEMENT.LabelItem[] = findParentNode(initArr, item.id).reverse();
    setSelectData(newAry);
    setCurrentLabelItem(newAry[0]);
  };

  const handleDragStart = (info: NodeDragEventParams) => {
    console.log(info, 'handleDragStart');
    const node: any = info?.node;
    if (node.id === 'all') {
      return;
    }
  };
  const handleDrop = async (info: any) => {
    console.log(info, 'handleDrop');
    const { dragNode, node } = info;
    // const currentTagCode = dragNode.tagCode;
    const currentTagId = dragNode.id;
    // const currentTagName = dragNode.title;
    // const targetTagCode = node.tagCode;
    const targetTagId = node.id;
    if (dragNode?.children?.length > 0 && dragNode?.level < node?.level) {
      message.warning('存在子级的分类不可降级');
      return;
    }
    if (node?.level === 6) {
      message.warning('构件分类最多支持7级');
      return;
    }
    if (currentTagId && targetTagId) {
      const res = await updateComponentTagPosition({
        tagId: currentTagId,
        targetTagId: targetTagId === 'all' ? '' : targetTagId,
      });
      if (res.success) {
        getLabels();
      }
    } else {
      message.warning('请先创建标签后再拖拽');
    }
  };

  const handleCancel = () => {
    props.onCancel(isRefreshList);
    setIsRefreshList(false);
  };

  const onTransfer = useCallbackFn(async (categoryId: string) => {
    // console.log(deleteTagId, categoryId, '====categoryId');
    const res1 = await deleteComponentTag(deleteTagId, [categoryId]);
    if (res1?.success) {
      message.success('分类已删除');
      setShowTransferClassModal(false);
      setDeleteTagId('');
      getLabels();
      setIsRefreshList(true);
    }
  });

  const transferClasss = useMemo(() => {
    if (deleteTagId) {
      return formattree(initArr, [], deleteTagId);
    }
    return initArr;
  }, [initArr, deleteTagId]);

  return (
    <>
      <Modal
        title="标签配置"
        // centered
        width={600}
        destroyOnClose={true}
        wrapClassName="com_modal"
        visible={props.visible}
        maskClosable={false}
        onCancel={handleCancel}
        forceRender={true}
        footer={null}
        bodyStyle={{ padding: 0, height: 556 }}
      >
        {/* <div className={styles.main}>
        <div className={styles.container}>
          <Spin spinning={spinning} size="large">
            {!arr.length && (
              <div className={styles.empty}>
                <CustomEmpty />
              </div>
            )}
            {!!arr.length && (
              <div className={styles.list}>
                <Tree
                  rootStyle={{ background: '#f7f8fa' }}
                  switcherIcon={
                    <CaretDownOutlined style={{ fontSize: 10 }} className={styles.switcherIcon} />
                  }
                  treeData={
                    [
                      {
                        title: '全部',
                        key: 'all',
                        children: arr,
                        level: -1,
                        id: 'all',
                        tagCode: 'all',
                      },
                    ] as any
                  }
                  draggable={{
                    icon: false,
                  }}
                  onDragStart={handleDragStart}
                  onDrop={handleDrop}
                  onExpand={handleExpand}
                  defaultExpandAll
                  expandedKeys={expandedKeys}
                  autoExpandParent={autoExpandParent}
                  blockNode={true}
                  titleRender={(node: DataNode) => (
                    <ItemRender
                      node={node as DataNode & ELEMENT.LabelItem}
                      onAdd={handleAdd}
                      onDelete={handleDelete}
                      onSave={handleSave}
                      onCreate={handleCreate}
                      editing={editing}
                      setEditing={setEditing}
                      keyword={val}
                      getTreeItem={getTreeItem}
                      lastSelectItem={selectData[selectData.length - 1]}
                      setClickPanelItem={setClickPanelItem}
                      isClickTreeItem={isClickTreeItem}
                      setClickTreeItem={setClickTreeItem}
                    />
                  )}
                />
              </div>
            )}
          </Spin>
        </div>
      </div> */}
        <div className={styles.settingWrap}>
          <div className={styles.settingClass}>
            <div
              className={`${styles.clazz} ${currentClazz.id === 'category' ? styles.active : ''}`}
              onClick={() => setCurrentClazz({ id: 'category' })}
            >
              分类
            </div>
            <div
              className={`${styles.clazz} ${currentClazz.id === 'app' ? styles.active : ''}`}
              onClick={() => setCurrentClazz({ id: 'app' })}
            >
              应用
            </div>
          </div>
          <div className={styles.settingOp}>
            {currentClazz.id === 'category' ? (
              <Tree
                switcherIcon={
                  <CaretDownOutlined style={{ fontSize: 10 }} className={styles.switcherIcon} />
                }
                treeData={
                  [
                    {
                      title: '全部',
                      key: 'all',
                      children: arr,
                      level: -1,
                      id: 'all',
                      tagCode: 'all',
                    },
                  ] as any
                }
                draggable={{
                  icon: false,
                }}
                onDragStart={handleDragStart}
                onDrop={handleDrop}
                onExpand={handleExpand}
                defaultExpandAll
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                blockNode={true}
                titleRender={(node: DataNode) => (
                  <ItemRender
                    node={node as DataNode & ELEMENT.LabelItem}
                    onAdd={handleAdd}
                    onDelete={handleDelete}
                    onSave={handleSave}
                    onCreate={handleCreate}
                    editing={editing}
                    setEditing={setEditing}
                    keyword={val}
                    getTreeItem={getTreeItem}
                    lastSelectItem={selectData[selectData.length - 1]}
                    setClickPanelItem={setClickPanelItem}
                    isClickTreeItem={isClickTreeItem}
                    setClickTreeItem={setClickTreeItem}
                  />
                )}
              />
            ) : null}
            {currentClazz.id === 'app' ? <AppSetting title="应用" datas={settingDataTree} /> : null}
          </div>
        </div>
      </Modal>
      {showTransferClassModal ? (
        <TransferClass
          categoryOptions={transferClasss}
          onClose={() => {
            setShowTransferClassModal(false);
            setDeleteTagId('');
          }}
          onChange={onTransfer}
        />
      ) : null}
    </>
  );
};
export default ModalLabel;
